import BasisBankIcon from "assets/icons/BasisBankIcon";
import CartuBankIcon from "assets/icons/CartuBankIcon";
import CredoBankIcon from "assets/icons/CredoBankIcon";
import GeorgianBankIcon from "assets/icons/GeorgianBankIcon";
import LibertyIcon2 from "assets/icons/LibertyIcon2";
import NewBankIcon from "assets/icons/NewBankIcon";
import ProcBankIcon from "assets/icons/ProcBankIcon";
import TbcBankIcon from "assets/icons/TbcBankIcon";
import TeraBankIcon from "assets/icons/TeraBankIcon";
import bogIcon from "assets/images/bogIcon.svg";
import tbIcon from "assets/images/tbcIcon.svg";
import basisIcon from "assets/images/basis.svg";
import libertyIcon from "assets/images/libertyIcon.svg";
import credoIcon from "assets/images/credoIcon.svg";
import teraIcon from "assets/images/teraIcon.svg";
import procIcon from "assets/images/procIcon.svg";
import cartuIcon from "assets/images/cartuIcon.svg";
import OnlineBankIcon from "assets/icons/OnlineBankIcon";
import TronIcon from "assets/icons/TronIcon";
import PolygonIcon from "assets/icons/PolygonIcon";
import NewVisaIcon, { NewAmexIconTwo } from "assets/icons/NewVisaIcon";
import NewMasterIcon from "assets/icons/NewMasterIcon";

export const getTransactionStatusKey = (status, isSent) => {
  switch (status) {
    case "FAILED_BY_GET_INFO":
      return isSent ? "Sent" : "Failed";
    case "REFUNDED":
      return "Refunded";
    case "PARTIALLY_REFUNDED":
      return "Partial refund";
    case "SUCCESS":
      return "Successful";
    default:
      return isSent ? "Sent" : " Pending";
  }
};

export const getAmountColor = (status, isSent) => {
  switch (status) {
    case "FAILED_BY_GET_INFO":
      return isSent ? "#7d7d7d" : "#FD7171";
    case "REFUNDED":
      return "#FD7171";
    case "SUCCESS":
      return isSent ? "#7d7d7d" : "#8CC63F";
    default:
      return "#7d7d7d";
  }
};

export const categoryOptions = [
  { label: "All", value: "ALL" },
  { label: "Merchant Payments", value: "MERCHANT_PAYMENT" },
  { label: "Private Payments", value: "USER_PAYMENT" },
  { label: "Received", value: "RECEIVED" },
];

export const getTransactionType = (acquiringTransactionType) => {
  switch (acquiringTransactionType) {
    case "TIP":
      return "Tip";
    case "REQUEST":
      return "Request";
    case "LINK":
      return "Link";
    default:
      return "Standard";
  }
};

const phoneNumber = "+995 591 05 00 02";
//  ‘+995 591 05 00 02’;
const parsedPhoneNumber = `${phoneNumber.split(" ").join("")}`;
export function sendMessage(message, show, update) {
  const encodedMessage = encodeURIComponent(message);

  const whatsappWebURL = `https://wa.me/${parsedPhoneNumber}?text=${encodedMessage}`;

  const whatsappMobileURL = `whatsapp://send?phone=${parsedPhoneNumber}&text=${encodedMessage}`;

  const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(
    navigator.userAgent
  );
  fallbackToIntercom(message, show, update);
  if (isMobile) {
    // Attempt to open WhatsApp app on mobile
    openWhatsappApp(whatsappMobileURL)
      .then((isWhatsappAppAvailable) => {
        if (!isWhatsappAppAvailable) {
          // If the app isn't installed or doesn't open, fallback to WhatsApp Web
          window.open(whatsappWebURL, "_blank");
          fallbackToIntercom(message, show, update);
        }
      })
      .catch(() => {
        // Fallback in case of any other error
        window.open(whatsappWebURL, "_blank");
        fallbackToIntercom(message, show, update);
      });
  } else {
    // For desktops or non-mobile devices, always use WhatsApp Web
    window.open(whatsappWebURL, "_blank");
  }
}

function openWhatsappApp(url) {
  // Attempt to open the WhatsApp app by creating an invisible iframe
  const startTime = Date.now();
  const timeout = 3000; // Wait for 3 seconds to see if the app opens

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);

  return new Promise((resolve) => {
    setTimeout(() => {
      document.body.removeChild(iframe);
      const isWhatsappAppAvailable = Date.now() - startTime < timeout;
      resolve(isWhatsappAppAvailable);
    }, timeout);
  });
}

export const fallbackToIntercom = (message, show, update) => {
  show();
  update({ message });
};

export const getCardIcon = (cardType) => {
  switch (cardType) {
    case "AMEX":
      return <NewAmexIconTwo />;

    case "MasterCard":
      return <NewMasterIcon width="34" height="18" />;
    case "VISA":
      return <NewVisaIcon width="34" height="12" />;

    default:
      return <div className="w-[34px]"></div>;
  }
};

// const ibanProvider = iban.iban.slice(4, 6);
export const renderBankLogo = (
  ibanProvider,
  ibansView = false,
  selectView = false
) => {
  switch (ibanProvider) {
    case "BG":
      return ibansView ? (
        <img src={bogIcon} alt="BG" />
      ) : (
        <GeorgianBankIcon width="30" heigth="30" />
      );
    case "TB":
      return ibansView ? (
        <img src={tbIcon} alt="TB" />
      ) : (
        <TbcBankIcon width="30" heigth="30" />
      );
    case "BB":
      return ibansView ? (
        <img src={basisIcon} alt="BB" />
      ) : (
        <BasisBankIcon width="30" heigth="30" />
      );
    case "LB":
      return ibansView ? <img src={libertyIcon} alt="LB" /> : <LibertyIcon2 />;
    case "CD":
      return ibansView ? (
        <img src={credoIcon} alt="CD" />
      ) : (
        <CredoBankIcon width="30" heigth="30" />
      );
    case "KS":
      return ibansView ? (
        <img src={teraIcon} alt="KS" />
      ) : (
        <TeraBankIcon width="30" heigth="30" />
      );
    case "PC":
      return ibansView ? (
        <img src={procIcon} alt="PC" />
      ) : (
        <ProcBankIcon width="30" heigth="30" />
      );
    case "CR":
      return ibansView ? (
        <img src={cartuIcon} alt="CR" />
      ) : (
        <CartuBankIcon width="30" heigth="30" />
      );
    case "TRON":
      return ibansView || selectView ? (
        <TronIcon {...(selectView ? { width: "40px", height: "30px" } : {})} />
      ) : (
        <img src="/svg/tron.svg" alt="tron" />
      );

    case "POLYGON":
      return ibansView || selectView ? (
        <PolygonIcon
          {...(selectView ? { width: "40px", height: "30px" } : {})}
        />
      ) : (
        <img src="/svg/polygon.svg" alt="pl" />
      );
    default:
      return ibansView ? (
        <div className="w-[60px] h-[40px] bg-white rounded-lg flex items-center justify-center">
          <OnlineBankIcon />
        </div>
      ) : (
        <NewBankIcon width="20" heigth="30" />
      );
  }
};

export const getExceptionGroupMessages = (exceptionGroup) => {
  let groupTitle = "";
  let groupDescription = "";
  switch (exceptionGroup) {
    case 1:
      groupTitle = "Information is insufficent or invalid";
      break;
    case 2:
      groupTitle = "An error occurred Please try again";
      break;
    case 3:
      groupTitle = "Authorization error";
      break;
    case 4:
      groupTitle = "Provider error Please try again";
      break;
    case 5:
      groupTitle = "Data not found\nPlease try again";
      break;
    case 6:
      groupTitle = "Format error";
      break;
    case 7:
      groupTitle = "Information not found\nPlease try again";
      break;
    case 8:
      groupTitle = "Limit issue\n Please try";
      break;
    default:
      groupTitle = "Please try again";
  }
  return { groupTitle, groupDescription };
};

export const specialCharsRegex = /^[a-zA-Z0-9/?:().,'+\u10D0-\u10F0 -]+$/;
export const officialNameRegex = /^[a-zA-Z\u10D0-\u10F0 ]+$/;
export const ibanRegex = /^[A-Za-z0-9 ]*$/;
